import { useState } from "react";
import { Card, IconButton, Tooltip } from "@material-ui/core";
import { columnTextField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import DialogGalery from "./dialog-galery";
import { Create, Delete, Photo } from "@mui/icons-material";

export default function TableSolicitacaoDevolucao({
  products = [],
  setSelectedProduct,
  setToggleFormDialog,
  readOnly = false,
}) {
  const [showingPhoto, setShowingPhoto] = useState(null);

  const getTableColumns = [
    columnTextField({
      dataField: "idProduto",
      text: "Produto",
      align: "center",
    }),
    columnTextField({
      dataField: "NumeroNf",
      text: "Nota Fiscal",
      align: "center",
      formatter: (cell, row) => cell ?? row?.NumeroNota ?? row?.NF ?? "-",
    }),
    columnTextField({
      dataField: "name",
      text: "Descrição",
      align: "center",
    }),
    columnTextField({
      dataField: "quantity",
      text: "Quantidade",
      align: "center",
    }),
    columnTextField({
      dataField: "images",
      text: "",
      align: "center",
      formatter: (cell, _) => {
        if (!cell || cell.length === 0) {
          return;
        }

        return (
          <Tooltip title="Visualizar as imagens">
            <IconButton
              onClick={() => {
                setShowingPhoto(cell);
              }}
              size="small"
            >
              <Photo fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    ...(!readOnly
      ? [
          columnTextField({
            dataField: "editar",
            text: "",
            align: "center",
            formatter: (_, row) => {
              return (
                <Tooltip title="Editar produto">
                  <IconButton
                    onClick={() => {
                      setSelectedProduct(row);
                      setToggleFormDialog("edit");
                    }}
                    size="small"
                  >
                    <Create fontSize="small" />
                  </IconButton>
                </Tooltip>
              );
            },
          }),
          columnTextField({
            dataField: "deletar",
            text: "",
            align: "center",
            formatter: (_, row) => (
              <Tooltip title="Deletar produto">
                <IconButton
                  onClick={() => {
                    setSelectedProduct(row);
                    setToggleFormDialog("delete");
                  }}
                  size="small"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            ),
          }),
        ]
      : []),
  ];

  return (
    <>
      <Card>
        <ToolkitTable
          keyField="idTableProduct"
          dataTable={products}
          columnModel={getTableColumns}
          headerTitle="Lista de Produtos"
          pagination={{
            options: [25, 50, 100],
            defaultOption: 25,
          }}
        />
      </Card>

      {!!showingPhoto && (
        <DialogGalery
          onClose={() => setShowingPhoto(null)}
          images={showingPhoto}
        />
      )}
    </>
  );
}
